import Component from '@glimmer/component'
import { service } from '@ember/service'
import { use } from 'ember-resources'
import { keepLatest } from 'reactiveweb/keep-latest'
import { trackedFunction } from 'reactiveweb/function'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import { toRequestScope } from 'teacher-ui-client/services/reporting'
import { Product } from 'teacher-ui-client/utils/products'
import type ReportingService from 'teacher-ui-client/services/reporting'
import UiButtonLinkTo from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { hash } from '@ember/helper'

export interface OverusedWordsData {
  overused_words: string[]
}

interface Signature {
  Element: HTMLDivElement
  Args: {
    uiScope: ModelFor<ReportingUiScopeRoute>['uiScope']
  }
}

export class OverusedWords extends Component<Signature> {
  @service reporting!: ReportingService

  fetchData = trackedFunction(this, () => {
    const requestScope = toRequestScope(this.args.uiScope)

    const url = this.reporting.buildWritingLegendsUrl({
      product: Product.WL,
      requestScope,
      reportName: 'vocabulary/overused-words',
    })

    return this.reporting.fetchReport<OverusedWordsData>(url, {})
  })

  @use
  latestData = keepLatest({
    value: () => this.fetchData.value,
    when: () => this.fetchData.isPending,
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    {{#if this.latestData}}
      <div class="flex flex-wrap justify-center gap-4" ...attributes>
        {{#each this.latestData.overused_words as |word|}}
          <UiButtonLinkTo
            class="w-32"
            @route="reporting.ui-scope.writing-legends.vocabulary.overused-words-analyser"
            @query={{hash word=word}}
            @appearance={{ButtonAppearance.mutedWithActive}}
          >
            {{word}}
          </UiButtonLinkTo>
        {{/each}}
      </div>
    {{/if}}
  </template>
}

export default OverusedWords
